var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"align":"left"}},[_c('b-tabs',{attrs:{"vertical":"","pills":""}},[_c('b-tab',{attrs:{"title":"Single Precision"}},[_c('single')],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Double Precision"}},[_c('double')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1d24e7a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ieee754.vue
// module id = 315
// module chunks = 1